<script>
import AutocompleteCustom from "@/components/AutocompleteCustom.vue";
import formatSiretSiren from "@/filters/formatSiretSiren";
import MarcheStore from "@/stores/MarcheStore";
import { libelles } from "@/constants/libelles";
import EntrepriseStore from "@/stores/EntrepriseStore";

export default {
  components: { AutocompleteCustom },

  data: () => ({
    entreprisesSiret: [],
    searchParams: {},
    libelles,
    marcheIdsItems: []
  }),

  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      this.$emit('search', { searchParams: this.searchParams })
    },
    async onSiretSearch(siret) {
      this.entreprisesSiret = await EntrepriseStore.getBySiretOrLibelle(
        siret,
        false,
        this.searchParams.marcheId || '',
        false,
        false
      )
    },
    formatSiretSiren,
  },

  mounted() {
    MarcheStore.getAll().then(marches => {
      this.marcheIdsItems = marches.map(marche =>
        ({ text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id })
      )
    })
  }
}

</script>

<template>
  <b-card header="Rechecher">
    <b-form @submit="onSubmit">
      <b-row>
        <b-col cols="6">
          <b-form-group id="input-group-marches" label="Marché" label-for="input-marches"
            label-class="typo-required-field">
            <AutocompleteCustom id="input-marches" :items="marcheIdsItems" v-model="searchParams.marcheId"
              :placeholder="libelles.selectionnerMarche">
            </AutocompleteCustom>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group id="input-siret" label="SIRET / Raison Sociale Entreprise" label-for="input-siret">
            <AutocompleteCustom id="input-entrepriseId" :items="entreprisesSiret" v-model="searchParams.entrepriseId"
              @search="onSiretSearch" :formatter="formatSiretSiren">
            </AutocompleteCustom>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button type="submit" variant="primary">Soumettre</b-button>
    </b-form>
  </b-card>
</template>
